import { objectWithClassName } from "../utilities/create/jss.js";
import "../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../_virtual/index.js";
const classNamePrefix = "umd-animation-transition";
const keyFrameFadeInStart = {
  opacity: 0
};
const keyFrameFadeInEnd = {
  opacity: "1"
};
const keyFrameSlideUpStart = {
  transform: "translateY(50px)"
};
const keyFrameSlideUpEnd = {
  transform: "translateY(0)"
};
const keyFrameSlideRightStart = {
  transform: "translateX(-15vw)"
};
const keyFrameSlideRightEnd = {
  transform: "translateX(0)"
};
const keyFrameFadeInFromBottom = objectWithClassName({
  className: `${classNamePrefix}-keyframe-slide-in-from-left`,
  "@keyframes fade-in-from-bottom": {
    from: {
      ...keyFrameFadeInStart,
      ...keyFrameSlideUpStart
    },
    to: {
      ...keyFrameFadeInEnd,
      ...keyFrameSlideUpEnd
    }
  }
});
const keyFrameSlideInFromLeft = objectWithClassName({
  className: `${classNamePrefix}-keyframe-slide-in-from-left`,
  "@keyframes slide-in-from-left": {
    from: {
      ...keyFrameSlideRightStart
    },
    to: {
      ...keyFrameSlideRightEnd
    }
  }
});
const slideRight = objectWithClassName({
  ...keyFrameSlideInFromLeft,
  className: `${classNamePrefix}-slide-right`,
  [`@media (prefers-reduced-motion: no-preference)`]: {
    [`@supports (animation-timeline: scroll())`]: {
      animation: "slide-in-from-left forwards",
      animationTimeline: "view()",
      animationRangeStart: "0",
      animationRangeEnd: "100vh",
      transform: "translateX(-15vw)"
    }
  }
});
const fadeInFromBottom = objectWithClassName({
  ...keyFrameFadeInFromBottom,
  className: [
    `${classNamePrefix}-fade-bottom`,
    /** @deprecated Use 'umd-animation-transition-fade-bottom' instead */
    "umd-grid-fade-in"
  ],
  [`@media (prefers-reduced-motion: no-preference)`]: {
    animation: "fade-in-from-bottom 1s forwards",
    opacity: "0",
    transform: "translateY(50px)"
  }
});
export {
  fadeInFromBottom,
  slideRight
};
//# sourceMappingURL=transition.js.map
